import React, { useState } from "react";
import { Popover, Skeleton, Tooltip } from "antd";
import moment from "moment-timezone";
import { BellIcon, ChatNotify, AgentNotify } from "../../assets/svg";
import "./styles.scss";

import UserService from "../../service/UserService";
import { NotificationIcon } from "../../assets/svg/mobileIcon";
const userservice = new UserService();

const NotificatonPopover = (props) => {
  const [state, setState] = useState({
    notifications: [],
    page: 1,
    hasMore: true,
    isLoading: false,
    limit: 10,
  });
  const [visible, setVisible] = useState(false);
  const { notificationAlert } = props;
  const loadMore = async () => {
    if (!state.isLoading) {
      const { page, limit } = state;
      setState((st) => ({ ...st, isLoading: true }));

      const { rows } = await userservice.getNotifications(page, limit);
      const zone = moment.tz.guess(true);
      rows.forEach((item) => {
        const valUtc = item.createdAt;
        const valZone = moment.tz(valUtc, zone);
        item.createdTime = valZone.format("hh:mm A");
        item.createdDate = valZone.format("MM/DD/YYYY ");
      });
      if (rows?.length > 0) {
        setState((st) => ({
          ...st,
          isLoading: false,
          notifications: rows,
        }));
      } else {
        setState((st) => ({
          ...st,
          isLoading: false,
          hasMore: false,
        }));
      }
    }
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
    if (newVisible) {
      loadMore();
    } else {
      setState((st) => ({ ...st, notifications: [] }));
    }
  };

  const content = () => {
    const dates = [];

    const partition = (date) => {
      let displayDate = date;
      const yesterday = moment().subtract(1, "day");

      if (moment().isSame(moment(displayDate), "day")) {
        displayDate = "Today";
      } else if (yesterday.isSame(moment(displayDate), "day")) {
        displayDate = "Yesterday";
      } else {
        displayDate = moment(date).format(" MMMM DD, YYYY");
      }

      return (
        <div key={displayDate} className="notification-date-partition">
          <p>{displayDate}</p>
        </div>
      );
    };

    const notifications = (item) => (
      <li key={item.id} className="notification-list-item">
        <>
          <section className="notification-icon">
            {item.type === "0" ? (
              <Tooltip title="LiveChat">
                <ChatNotify />{" "}
              </Tooltip>
            ) : (
              <Tooltip title="LiveAgent">
                <AgentNotify />{" "}
              </Tooltip>
            )}
          </section>
          <section className="notification-msg">{item.msg}</section>
          <section className="notification-time">{item.createdTime}</section>
        </>
      </li>
    );

    return (
      <>
        {state.isLoading && <Skeleton />}
        {state.notifications.length > 0 ? (
          <ul className="notifications-list">
            {state.notifications &&
              state.notifications.map((item) => {
                const element = [];
                if (
                  item.createdAt &&
                  !dates.includes(item.createdAt.slice(0, 10))
                ) {
                  dates.push(item.createdAt.slice(0, 10));
                  element.push(partition(item.createdAt.slice(0, 10)));
                }
                element.push(notifications(item));

                return element;
              })}
          </ul>
        ) : (
          !state.isLoading && (
            <p className="no-data-message">No notifications to show.</p>
          )
        )}
      </>
    );
  };

  return (
    <Popover
      data-testid="notification-wrapper"
      overlayClassName="wrapper-notify"
      content={content}
      title="Notifications"
      placement="bottom"
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      <section className="bell-icon">
        {!visible ? (
          <>
            {notificationAlert && <span className="notification-icon" />}
            <span className="hide-for-mob">
              <BellIcon />
            </span>
            <span className="display-in-mob">
              <NotificationIcon />
            </span>
          </>
        ) : (
          <span className="active">
            <span className="hide-for-mob">
              <BellIcon />
            </span>
            <span className="display-in-mob">
              <NotificationIcon />
            </span>
          </span>
        )}
      </section>
    </Popover>
  );
};
export default NotificatonPopover;
